/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInstancePool = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.5 6h-1v5H2v7h20v-7h-4.5V6h-1zm4.5 5H8.5V8h7v3zm-8 5v-3h7v3zm9 0v-3h7v3zm1.5-7h-1v1h1zM9 14h1v1H9zm9 0h1v1h-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInstancePool as InstancePool };
